import $ from 'jquery';
$(document).ready(() => {

   // console.log('in linkedin redirect file');
   let linkedInIcons = [];
   const linkedInIconsIntroPara = document.querySelectorAll('.intro-para-icons .icon-li');
   // console.log(linkedIcons);

   if(linkedInIconsIntroPara && linkedInIconsIntroPara.length > 0) {
      linkedInIcons = [
          ...linkedInIcons,
          ...linkedInIconsIntroPara,
      ]
   }

   if(linkedInIcons.length > 0 ){
      import(/* webpackChunkName: "dompurify" */'dompurify').then(({default: DOMPurify}) => {
         linkedInIcons.forEach(iconItem => {
            const anchorElement = iconItem;
            const shareUrl = encodeURI(`${DOMPurify.sanitize(window.location.origin)}${DOMPurify.sanitize(window.location.pathname)}`);
            console.log(shareUrl);
            // console.log(encodedLink);
            const linkedinShareUrl = `https://www.linkedin.com/shareArticle?url=${shareUrl}`;
            anchorElement.href = linkedinShareUrl;
            anchorElement.addEventListener('click', (e) => {
               e.preventDefault();
               const popupWidth = 600;
               const popupHeight = 400;
               const left = (window.innerWidth-popupWidth ) / 2;
               const top = (window.innerHeight-popupHeight) / 2;
               // const currentHref = anchorElement.href;
               // console.log(currentHref);
               // const urlParams = new URL(currentHref).searchParams;
               // const shareUrl = urlParams.get('url');

               //window.open(linkedUrl, '_blank');
               // Open the LinkedIn share link in a centered popup window
               window.open(linkedinShareUrl, 'LinkedIn Share', `width=${popupWidth},height=${popupHeight},left=${left},top=${top}`);
            })
         })
      });
   }
});